<div class="table-loader">
    <div class="tank">
        <div class="fill"></div>
        <div class="flow"></div>
    </div>
</div>
